import { IApplicationContext } from '../../types/applicationContext';
import { ResponseError } from '../../errors/ResponseError';
import { mapFavoriteDealType, mapFavoriteEntityType } from './mapFavoriteParameters';
import { TAddToFavoriteResponse, TFavoriteServiceParameters } from './types';

type TAddFavoriteErrorResponse = {
  errors?: unknown;
  message?: string;
};

type TAddFavoriteResponse =
  | {
      response: TAddToFavoriteResponse;
      statusCode: 200;
    }
  | {
      response: TAddFavoriteErrorResponse;
      statusCode: number;
    };

function isAddFavoriteErrorResponse(
  response: TAddFavoriteResponse,
): response is { response: TAddFavoriteErrorResponse; statusCode: number } {
  return response.statusCode !== 200;
}

export async function addToFavorite(
  { httpApi, logger }: IApplicationContext,
  { dealType, offerId, offerType }: TFavoriteServiceParameters,
): Promise<TAddToFavoriteResponse> {
  try {
    const response = (await httpApi.fetch({
      v: 1,
      apiType: 'public',
      method: 'POST',
      microserviceName: 'favorites',
      pathApi: '/v1/add-favorite/',
      request: {
        contentType: 'json',
        parameters: {
          addToFolder: true,
          dealType: mapFavoriteDealType(dealType),
          entityId: offerId,
          entityType: mapFavoriteEntityType(offerType),
        },
      },
      response: {
        200: {
          contentType: 'json',
        },
        400: {
          contentType: 'json',
        },
      },
    })) as TAddFavoriteResponse;

    if (isAddFavoriteErrorResponse(response)) {
      throw new ResponseError({
        domain: 'addToFavorite',
        message: response.response.message || 'Код ответа не 200',
        details: { errors: JSON.stringify(response.response.errors) },
      });
    }

    if (!response.response.isAdded) {
      throw new ResponseError({
        domain: 'addToFavorite',
        message: 'Не добавлено в избранное',
        details: { response: JSON.stringify(response.response) },
      });
    }

    return response.response;
  } catch (error) {
    logger.error(error, {
      offerId,
      domain: 'addToFavorite',
    });

    throw error;
  }
}
